import {
  ADMIN_MANAGER_CREATING_FAIL,
  ADMIN_MANAGER_CREATING_SAVING,
  ADMIN_MANAGER_CREATING_SUCCESS,
  ADMIN_MANAGER_UPDATING_SAVING,
  ADMIN_MANAGER_UPDATING_SUCCESS,
  ADMIN_MANAGER_UPDATING_FAIL,
  RESET_CREATE_MANAGER_TRAINER_STATE,
  AdminCreateUpdateManagerAction,
  AdminCreateUpdateManagerState,
  ADMIN_MANAGER_RESET_SEARCH,
} from "../../actions/AdminTeamManagers/types";

const initialState: AdminCreateUpdateManagerState = {
  errorToCreate: false,
  errorToUpdate: false,
  successToCreate: false,
  successToUpdate: false,
  isSaving: false,
  errorMessage: null,
};

const adminCreateUpdateManagerState = (
  state = initialState,
  action: AdminCreateUpdateManagerAction
) => {
  switch (action.type) {
    case RESET_CREATE_MANAGER_TRAINER_STATE:
      return {
        ...state,
        errorToCreate: false,
        errorToUpdate: false,
        successToCreate: false,
        successToUpdate: false,
        isSaving: false,
        errorMessage: null,
      };
    case ADMIN_MANAGER_CREATING_SAVING:
    case ADMIN_MANAGER_UPDATING_SAVING:
      return {
        ...state,
        isSaving: true,
      };
    case ADMIN_MANAGER_CREATING_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isSaving: false,
        errorToCreate: false,
        successToCreate: true,
      };
    case ADMIN_MANAGER_UPDATING_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isSaving: false,
        errorToUpdate: false,
        successToUpdate: true,
      };
    case ADMIN_MANAGER_CREATING_FAIL: {
      const errorMessages = [];
      action.errorMessage?.graphQLErrors.forEach((err) => {
        if (err?.extensions?.errorMessage) {
          errorMessages.push(err?.extensions?.errorMessage);
        }
      });
      return {
        ...state,
        errorMessage: errorMessages.join("\n"),
        errorToCreate: true,
        successToCreate: false,
        isSaving: false,
      };
    }
    case ADMIN_MANAGER_UPDATING_FAIL: {
      const errorMessages = [];
      action.errorMessage?.graphQLErrors.forEach((err) => {
        if (err?.extensions?.errorMessage) {
          errorMessages.push(err?.extensions?.errorMessage);
        }
      });
      return {
        ...state,
        errorMessage: errorMessages.join("\n"),
        errorToUpdate: true,
        successToUpdate: false,
        isSaving: false,
      };
    }
    case ADMIN_MANAGER_RESET_SEARCH:
      return {
        ...state,
        errorMessage: null,
        isSaving: false,
        errorToUpdate: false,
        successToUpdate: true,
      };
    default:
      return state;
  }
};

export default adminCreateUpdateManagerState;
